import { Header } from 'components'

// Imported from where VRG-643 built it, not copied: the SEO view is ONE set of
// components, and the GTM page and the old Analytics tab must never be able to drift
// apart because they were never two things.
import { SeoPanel } from '../InternalAnalyticsPage/components/seo/SeoPanel'

/**
 * `/internal/gtm/seo` — VRG-672: SEO & AEO, moved out of Analytics into GTM.
 *
 * WHY IT MOVED. Analytics answers "how is the business doing" (the website funnel, and
 * ROI to come). SEO & AEO answers "how is Vera FOUND", which is a go-to-market channel —
 * channel #7 in Traction, and one of the two Spencer set as Focus. It also is not
 * read-only: the Recommendations queue is approved and rejected here, so it is a desk
 * someone works, which is what a GTM row is.
 *
 * THE COMPONENTS DID NOT MOVE, deliberately. `SeoPanel` and its cards still live under
 * `InternalAnalyticsPage/components/seo/`, because VRG-643 and VRG-667 have open branches
 * editing those files in place, and a directory move now would turn each of their next
 * folds into a rename conflict. Relocating them to this page's folder is a mechanical
 * follow-up once those branches land; nothing else depends on where they sit.
 *
 * The old address, `/internal/analytics?tab=seo`, redirects here with its `seo=`,
 * `market=`, `range=` and `review=` params intact (App.tsx), because the biweekly review
 * email and Slack post already sent carry it.
 *
 * Gate: `internal_gtm_view` since VRG-684 (routes/internalAccess.ts); it kept the analytics gate until then.
 */
export const GtmSeoPage = () => (
  <>
    <Header title="SEO & AEO" />
    <SeoPanel />
  </>
)
